export default "__VITE_ASSET__BBIE5wuv__"